import { Component, ViewEncapsulation, OnInit, ElementRef, ViewChild } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { KYMW1800Model } from './kymw1800.model';
import { FileDownloadConfirmService } from '../../../commons/kymw02/file-download-confirm/file-download-confirm.service';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { GetImageExistenceListService } from './api-services/get-image-existence-list.service';
import { RadioLabelComponent } from '../../../commons/kymw02/radio-label/radio-label.component';
import { OrderCodeTextInputComponent } from '../../../commons/kymw02/text-input/order-code-text-input/order-code-text-input.component';

/**
 * 画像ﾁｪｯｸﾘｽﾄ出力
 *
 * @export KYMW1800Component
 * @class KYMW1800Component
 * @implements {OnInit}
 */
@Component({
  selector: 'app-kymw1800',
  templateUrl: './kymw1800.component.html',
  styleUrls: ['./kymw1800.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class KYMW1800Component extends PlessViewHelperSub implements OnInit {

  @ViewChild('txti_OrderCode', { static: true }) txti_OrderCode: OrderCodeTextInputComponent;
  @ViewChild('rdb_Existence', { static: true }) rdb_Existence: RadioLabelComponent;

  // 親画面からの連携値
  param: any;

  kymw1800Model: KYMW1800Model = new KYMW1800Model();

  /** 企画仮確定 コード値 ctp004:01「次企画仮確定」 */
  public KIKAKU_KARIKAKUTEI_CODE = '01';

  /** 生協コードマスタ */
  public coopData: Array<any> = null;

  /**
   *Creates an instance of KYMW4100Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {FileDownloadConfirmService} fileDownloadConfirmService
   * @param {KYMW00Model} kymw00Model
   * @param {GetImageExistenceListService} getImageExistenceListService
   * @memberof KYMW4100Component
   */
  constructor(
    public dialogService: PlessDialogServiceSub,
    public fileDownloadConfirmService: FileDownloadConfirmService,
    public getImageExistenceListService: GetImageExistenceListService,
    public kymw00Model: KYMW00Model,
    public elementRef: ElementRef,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof PhaseRegistComponent
   */
  ngOnInit(): void {
    this.componentName = 'KYMW1800';

    // 生協コード値のマップ
    this.coopData = [];
    this.coopData['ckb_CoopCode_I'] = this.kymw00Model.COOP_CODE_IB;
    this.coopData['ckb_CoopCode_To'] = this.kymw00Model.COOP_CODE_TO;
    this.coopData['ckb_CoopCode_Gu'] = this.kymw00Model.COOP_CODE_GU;
    this.coopData['ckb_CoopCode_Chi'] = this.kymw00Model.COOP_CODE_TI;
    this.coopData['ckb_CoopCode_Sa'] = this.kymw00Model.COOP_CODE_SA;
    this.coopData['ckb_CoopCode_Tok'] = this.kymw00Model.COOP_CODE_TK;
    this.coopData['ckb_CoopCode_Na'] = this.kymw00Model.COOP_CODE_NA;
    this.coopData['ckb_CoopCode_Ni'] = this.kymw00Model.COOP_CODE_NI;
    this.coopData['ckb_CoopCode_Ku'] = this.kymw00Model.COOP_CODE_KU;

    this.initKYMW1800();
  }

  /**
   * 出力ボタンを押下した時に呼び出されるメソッド。
   *
   * @param event コールバック・イベントへの参照
   */
  public eventCSVOut_CLICKHandler(): void {
    // 入力チェック
    if (!this.inputCheck()) {
      return;
    }

    const vo = {
      outputType: '',
      orderCode: '',
      mediumType: '',
      delivCatalogId: '',
      coopCodeList: []
    };
    // 出力リスト
    vo.outputType = this.kymw1800Model.outputType;
    // 受注コード
    vo.orderCode = this.kymw1800Model.orderCode;
    // 媒体
    vo.mediumType = PlessViewUtilsSub.nullToBlank(this.kymw1800Model.mediumType);
    // 配達企画回（翌週）
    vo.delivCatalogId = this.txti_OrderCode.selectedCatalogID;
    // 会員生協
    vo.coopCodeList = [];
    if (this.kymw1800Model.ibaraki) {
      vo.coopCodeList.push(this.coopData['ckb_CoopCode_I']);
    }
    if (this.kymw1800Model.tochigi) {
      vo.coopCodeList.push(this.coopData['ckb_CoopCode_To']);
    }
    if (this.kymw1800Model.gunma) {
      vo.coopCodeList.push(this.coopData['ckb_CoopCode_Gu']);
    }
    if (this.kymw1800Model.chiba) {
      vo.coopCodeList.push(this.coopData['ckb_CoopCode_Chi']);
    }
    if (this.kymw1800Model.saitama) {
      vo.coopCodeList.push(this.coopData['ckb_CoopCode_Sa']);
    }
    if (this.kymw1800Model.tokyo) {
      vo.coopCodeList.push(this.coopData['ckb_CoopCode_Tok']);
    }
    if (this.kymw1800Model.nagano) {
      vo.coopCodeList.push(this.coopData['ckb_CoopCode_Na']);
    }
    if (this.kymw1800Model.niigata) {
      vo.coopCodeList.push(this.coopData['ckb_CoopCode_Ni']);
    }
    if (this.kymw1800Model.kuruco) {
      vo.coopCodeList.push(this.coopData['ckb_CoopCode_Ku']);
    }

    this.getImageExistenceListService.execute(this.kymw1800Model, vo, (data: any) => {
      const EXISTENCE_LIST_PREFIX = '画像有無リスト_';
      const VERSION_CHECK_LIST_PREFIX = '画像バージョンチェックリスト_';
      const index: number = data.FileName.lastIndexOf('_');
      const tmpCode: string = data.FileName.substring(index - 1, index);

      // サーバファイル名から ("KYMW1890_" OR "KYMW1891_" ) 判定
      const filePrefix: string = tmpCode === '0' ?
        EXISTENCE_LIST_PREFIX : VERSION_CHECK_LIST_PREFIX;

      // ファイル名の設定
      const fileName = filePrefix + PlessViewUtilsSub.formatedNowDate('YYYYMMDD_hhmmss') + '.CSV';
      this.fileDownloadConfirmService.show(data.FileName, fileName);
    });
  }

  /**
   *  画面情報の初期化
   */
  private initKYMW1800(): void {
    // 受注コードをクリアに連動して、配達企画回（翌週）がクリア、媒体が再作成される。
    this.kymw1800Model.orderCode = '';
    // 出力タイプ
    this.kymw1800Model.outputType = '1';
    // 会員生協
    this.kymw1800Model.ibaraki = true;
    this.kymw1800Model.tochigi = true;
    this.kymw1800Model.gunma = true;
    this.kymw1800Model.chiba = true;
    this.kymw1800Model.saitama = true;
    this.kymw1800Model.tokyo = true;
    this.kymw1800Model.nagano = true;
    this.kymw1800Model.niigata = true;
    this.kymw1800Model.kuruco = true;
    // デフォルトフォーカス設定
    this.rdb_Existence.setFocus();
  }

  /**
   * メニュー「最新の情報に更新」押下時の処理
   *
   */
  private reloadKYMW1800(): void {

    this.initKYMW1800();
  }

  /**
   * 入力チェック
   *
   * @return true:OK false:NG
   */
  private inputCheck(): boolean {
    // 受注コード必須チェック
    if (PlessViewUtilsSub.isEmpty(this.kymw1800Model.orderCode)) {
      this.dialogService.openAlertGetMessage('W0001', ['受注コード']);
      return false;
    }
    // 受注コード存在チェック
    if (PlessViewUtilsSub.isEmpty(this.txti_OrderCode.selectedCatalogID)) {
      this.dialogService.openAlertGetMessage('E0122', ['受注コード']);
      return false;
    }

    // 媒体区分
    const mediumType = PlessViewUtilsSub.nullToBlank(this.kymw1800Model.mediumType);

    // 媒体区分必須チェック
    if (PlessViewUtilsSub.isEmpty(this.kymw1800Model.mediumType)) {
      this.dialogService.openAlertGetMessage('E0103', ['媒体']);
      return false;
    }

    // 会員生協
    if (!this.kymw1800Model.ibaraki &&
      !this.kymw1800Model.tochigi &&
      !this.kymw1800Model.gunma &&
      !this.kymw1800Model.chiba &&
      !this.kymw1800Model.saitama &&
      !this.kymw1800Model.tokyo &&
      !this.kymw1800Model.nagano &&
      !this.kymw1800Model.niigata &&
      !this.kymw1800Model.kuruco) {
      this.dialogService.openAlertGetMessage('E0103', ['会員生協']);
      return false;
    }
    return true;
  }

  /**
   * 受注コード入力変更時のイベント
   */
  public eventOrderCode_CHANGEHandler(): void {
    this.kymw1800Model.mediumType = '';
  }
}
